import React from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from 'reactstrap'
import styles from './BoldSlatePlugin.scss'
import { TYPE, TRIGGER_KEY, hasBold, onClickButton } from './BoldSlatePluginContainer'

class BoldButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { state: editorState, noTooltip, onChange, style } = this.props
    const isActive = hasBold(editorState)

    const boldStyles = {fontFamily: 'serif'}

    return (
      <Button
        id={'BoldButton' + (noTooltip ? '' : this.uid)}
        style={{...style, ...boldStyles}}
        onClick={e => onChange(onClickButton(e, editorState))}
        color={isActive ? 'primary' : 'secondary'}
        className={styles.BoldButton}
      > B
        {
          !noTooltip &&
          <Tooltip placement='top' isOpen={this.state.tooltipOpen} target={'BoldButton' + this.uid} toggle={this.toggle}>
            {TYPE} (CTL+{TRIGGER_KEY.toUpperCase()})
          </Tooltip>
        }
      </Button>
    )
  }
}

BoldButton.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  noTooltip: PropTypes.bool,
  style: PropTypes.object
}

export default BoldButton



// WEBPACK FOOTER //
// ./src/components/BoldSlatePlugin/BoldButton.js